import { useEffect, useState } from 'react';
export function useRelativeMousePosition(ref) {
    const [position, setPosition] = useState(undefined);
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const controller = new AbortController();
        const setMousePosition = (event) => {
            const rect = element.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            setPosition({ x, y });
        };
        element.addEventListener('mousemove', setMousePosition, { signal: controller.signal, passive: true });
        element.addEventListener('mouseenter', setMousePosition, { signal: controller.signal, passive: true });
        element.addEventListener('mouseleave', () => setPosition(undefined), { signal: controller.signal, passive: true });
        return () => controller.abort();
    }, []);
    return position;
}
